import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import './inbox.css';

function DirectMessagePage() {
  let { catId } = useParams();

  let inboxes = JSON.parse(localStorage.getItem("inboxesSaved"));
  console.log(inboxes)
  let name = inboxes[catId].name

  const [messages, setMessages] = useState(inboxes[catId].messages);

  const [inputMessage, setInputMessage] = useState('');

  const sendMessage = async (event) => {
    event.preventDefault();
    if (!inputMessage.trim()) return; // Prevent sending empty messages

    // Sent
    let newMessages = {
      text: inputMessage,
      timestamp: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
      type: 'sent' // Assuming all new messages are sent by the user
    };
    setMessages([...messages, newMessages]);
    // localStorage.setItem("inboxesSaved", inboxes);

    setInputMessage(''); // Reset input field

    // Received
    await fetch('https://love-paws-api.simplecode.gr/inbox/send_message', {
        method: 'POST',
		headers: {
        	'Content-Type': 'application/json'
    	},
        body: JSON.stringify({
			"data" : {
				"recipient" : name,
				"msg" : inputMessage
			},
			"metadata" : {}
        })
    })
    .then(response => response.json())
    .then(data => {      
        let newMessage = {
          text: data.data.msg,
          timestamp: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
          type: 'received'
        }
        setMessages((m) => [...m, newMessage]);

        inboxes = JSON.parse(localStorage.getItem("inboxesSaved"));
        inboxes[catId].messages.push(newMessage);
        localStorage.setItem("inboxesSaved", JSON.stringify(inboxes));
    })
    .catch(error => {
        console.error('Error:', error);
    });
  };

  return (
    <div className="messagesContainer">
      <h2>Conversation with {name}</h2>
      <div className="messageExchange">
        {messages.map((message, index) => (
          <div key={index} className={`message ${message.type}`}>
            <div className="text">{message.text}</div>
            <div className="timestamp">{message.timestamp}</div>
          </div>
        ))}
      </div>
      <form className="sendMessageForm" onSubmit={sendMessage}>
        <input
          type="text"
          placeholder="Type a message..."
          className="messageInput"
          value={inputMessage}
          onChange={(e) => setInputMessage(e.target.value)}
        />
        <button type="submit" className="sendButton">Send</button>
      </form>
    </div>
  );
}

export default DirectMessagePage;
